import '../../Styles/progressbar.scss';


const customModals = document.querySelectorAll(".custom-modal");

customModals.forEach((customModal) => {
    const cancelButton = document.querySelector(`[data-modal-id="${customModal.id}"] .cancel-button`);
    const body = document.querySelector("body");
    const modalButtonSecondary = customModal.querySelector(".modal-button.secondary");
    const modalButtonPrimary = customModal.querySelector(".modal-button.primary");
    const closeButton = customModal.querySelector(".close-button");    
    
    if (cancelButton) {
        
        function modal(show){
            if (show) {
                body.classList.add("modal-open");
                customModal.classList.add("show");
                customModal.classList.add("d-block");
                customModal.classList.add("progressbar__modal-bg");
            } else {
                body.classList.remove("modal-open");
                customModal.classList.remove("show");
                customModal.classList.remove("d-block");
                customModal.classList.remove("progressbar__modal-bg");
            }
        }
    
        cancelButton.onclick = function () {
            modal(true);
        }
    
        if (modalButtonSecondary) {
            modalButtonSecondary.onclick = function () {
                modal();
            }
        }
    
        if (modalButtonPrimary) {
            modalButtonPrimary.onclick = function () {
                modal();
            }
        }
    
        if (closeButton) {
            closeButton.onclick = function () {
                modal();
            }
        }
    }
});
